module.exports = __webpack_public_path__ + "static/media/Dark.b6c08e32.svg";